import React from 'react';
import './Footer.css';
const Footer = () => {
    return (
        <div className="footer">
            <p>
                Copyright &copy; <span className="featured-text">Fitlang</span>
            </p>
            <p>All rights reserved</p>
        </div>
    );
};

export default Footer;
